import { render, staticRenderFns } from "./cardAppeal.vue?vue&type=template&id=121a08dc&scoped=true"
import script from "./cardAppeal.vue?vue&type=script&lang=js"
export * from "./cardAppeal.vue?vue&type=script&lang=js"
import style0 from "./cardAppeal.vue?vue&type=style&index=0&id=121a08dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a08dc",
  null
  
)

export default component.exports